<template>
  <div>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Vehicle Destination Map
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" class="my-0 py-0 flex-wrap">
            <div class="ml-4">Total No. of Vehicles: {{ vehicleDetails.totalVehicleCount }}</div>
          </v-col>
          <v-col cols="6" class="my-0 py-0">
            <div class="ml-4">Route Assigned to Vehicles: {{ vehicleDetails.routeAssignedVehicleCount }}</div>
          </v-col>
        </v-row>
        <div>
          <v-dialog v-model="dialogInActive" persistent max-width="800px">
              <v-card>
                <v-card-title class="text-center mb-10">
                  <span class="headline ml-auto mr-auto">Below Vehicle's Were Deactivated.</span>
                </v-card-title>
                <v-card-subtitle>
                  <v-data-table
                    :headers="headers1"
                    :items="tableData"
                    :items-per-page="5"
                    item-key="name"
                    class="elevation-1"
                  >
                  </v-data-table>
                </v-card-subtitle>
                <v-card-actions class="d-flex justify-center">
                  <v-spacer></v-spacer>
                  <v-btn class="ma-5" @click="handleInactiveDialog">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        <v-row>
          <v-col class=" mt-5 ml-7" cols="4">
            <v-text-field
              :disabled="!vehicleList.length"
              label="Search Vendor"
              v-model="searchKey"
              @input="filterVendors"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="3">

          </v-col>
          <v-col class="mt-5 text-right" cols="4">
            <v-btn class="mb-2" v-if="!isAssignRouteToAll" @click="assignRouteToAll" :disabled="!vehicleList.length">Assign Route to All</v-btn>
            <v-btn color="success" :disabled="!checkAllAssigned"  class="mb-2 mr-2" v-if="isAssignRouteToAll" @click="saveAssignRouteToAll">Save</v-btn>
            <v-btn color="error" class="mb-2 ml-2" v-if="isAssignRouteToAll" @click="emptySelection">Cancel</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="!searching ? vehicleList : vendorsFiltered"
          :page.sync="currentPage"
          item-key="busID"
          class="tableData customtablevehicle"
          @toggle-select-all="assignRouteToAll('headerCheckbox')"
          :show-select="(!searching ? vehicleList.length : vendorsFiltered.length) > 0"
        >
          <template v-slot:item="{ item, isSelected, select, index }">
            <tr>
              <td @click="toggle(isSelected, select, index)">
                <v-checkbox
                  v-model="isSelected"
                  class="pe-2"
                  @change="toggle(isSelected, select, index)"
                ></v-checkbox>
              </td>
              <td>{{ item.srNo }}</td>
              <td>
                {{ item.vehicleRegistrationNumber ? item.vehicleRegistrationNumber : '-' }} -
                {{ item.transportVendor ? item.transportVendor.ownerName : '-' }}
              </td>
              <td style="min-width: 20rem">
                <div class="table-cell-select"  v-if="isSelected"
                  :ref="el => { if (el) dropdownRefs[item.busID] = el }"
                >
                  <div class="select-field" @click="toggleDropdown(item.busID)">
                    {{vendorsDestinationFormData[item.srNo - 1] && vendorsDestinationFormData[item.srNo - 1].destinationID ? getDestinationLabel(vendorsDestinationFormData[item.srNo - 1].destinationID) : "Select Destination"}}

                    <span class="dropdown-arrow">▼</span>
                  </div>
                  <div v-if="isOpen && openIndex === item.busID" class="select-dropdown selectdropdownadd">
                    <div class="add-option addOptionsticky" @click="showAddOption(item.busID)" v-if="!isAdding">
                      + Add Destination Option
                    </div>
                    <div v-if="isAdding" class="add-option-input-container">
                      <input
                        v-model="newOptionName"
                        @keyup.enter="addOption"
                        class="add-option-input"
                        placeholder="Type Destination text here"
                        ref="newOptionInput"
                      />
                      <v-btn icon :disabled="disableOptionSave()" @click.stop="addOption">
                        <v-icon color="green">mdi-check-circle</v-icon>
                      </v-btn>
                      <v-btn @click.stop="cancelAdd" icon>
                        <v-icon class="ml-2" color="red" >mdi-close-circle</v-icon>
                      </v-btn>

                    </div>
                    <div
                      v-for="option in filteredOptions"
                      :key="option.id"
                      class="select-option"
                      :class="{ selected: option.id === item.destination?.id }"
                    >
                      <template
                        v-if="editingOption && editingOption.id === option.id"
                      >
                        <input
                          v-model="editingOptionName"
                          @keyup.enter="saveOption"
                          @keyup.esc="cancelEdit"
                          class="edit-input"
                          :ref="el => { if (el) editInputRefs[item.destinationID] = el }"
                        />
                        <v-btn icon :disabled="disableOptionSave('edit')" @click.stop="saveOption">
                          <v-icon color="green">mdi-check-circle</v-icon>
                        </v-btn>
                        <v-btn @click.stop="cancelAdd" icon>
                          <v-icon class="ml-2" color="red">mdi-close-circle</v-icon>
                        </v-btn>
                      </template>
                      <template v-else>
                        <span
                          class="option-name"
                          @click="selectOption(option, item)"
                          >{{ option.destination }}</span
                        >
                        <span class="edit-icon" @click.stop="editOption(option)"
                          ><v-icon class="ml-2" color="" style="font-size: 18px;">mdi mdi-pencil</v-icon></span
                        >

                      </template>
                    </div>
                  </div>
                </div>
                <div  v-else>{{ item.transportDestination ? item.transportDestination.destination : '-' }}</div>
              </td>
              <td>
                <!-- <v-btn v-if="isSelected && !isAssignRouteToAll && !item.transportDestination && !item.destinationID" small @click="assignRoute(item,(currentPage - 1) * 10 + index)">Assign Now</v-btn> -->
                <div v-if="isAssignRouteToAll">-</div>
                <v-btn class="mr-2" v-if="!isAssignRouteToAll && isSelected" @click="assignRoute(item, item.srNo - 1)" small><v-icon color="success" >mdi-check-circle-outline</v-icon></v-btn>
                <v-btn class="ml-2" v-if="!isAssignRouteToAll && isSelected" @click="removeSelected(select, item.srNo - 1, item)" small><v-icon color="red">mdi-close-circle-outline</v-icon></v-btn>
                <v-btn v-if="!isAssignRouteToAll && !isSelected && item.transportDestination && item.destinationID" small @click="editRoute(select)">Edit</v-btn>
                <v-btn v-if="!isAssignRouteToAll && !isSelected && !item.transportDestination && !item.destinationID" small @click="editRoute(select)">Assign Now</v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="justify-center text-center">
              <div>No Vehicles Found </div>
              <div>
                <span>Please click here to </span>
                <router-link :to="{ name: 'VendorAdd', params: {} }" >
                  Add Vendor
                </router-link>

              </div>
            </v-card-subtitle>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import stores from '@/stores'

export default {
  name: 'VehicleDestinationMap',

  data () {
    return {
      showAtStart: true,
      currentPage: 1,
      isAssignRouteToAll: false,
      isInputVisible: false,
      franchiseeID: null,
      destinations: [],
      isDestinationEditing: null,
      editingDestination: '',
      vehicleDetails: { rows: [], totalVehicleCount: 0, routeAssignedVehicleCount: 0 },
      vehicleList: [],
      inActiveVehicleDetails: [],
      selected: [],
      vendorsDestinationFormData: [],
      searchKey: null,
      searching: false,
      isLoading: false,
      inProgress: false,
      headers: [
        { text: 'Sr No.', value: 'srNo', sortable: false },
        { text: 'Vehicles-Vendor Name', value: 'vendorName', sortable: false },
        { text: 'Destination', value: 'destination', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' }
      ],
      isSelected: false,
      newDestination: '',
      showAddDestinationInputField: [],
      dialogInActive: false,
      inactiveDialogVerified: false,
      tableData: [],
      headers1: [
        { text: 'Sr. No', value: 'srNo', sortable: false },
        { text: 'Vehicle Number', value: 'vehicleNumber', sortable: false },
        { text: 'Destination', value: 'destination', sortable: false },
        { text: 'Deactivation Reason', value: 'deactivationReason', sortable: false }
      ],
      isOpen: false,
      isAdding: false,
      newOptionName: '',
      openIndex: null,
      editingOption: null,
      editingOptionName: '',
      localValue: this.value,
      dropdownRefs: {},
      editInputRefs: {}
    }
  },
  async created () {
    if (this.franchisee.id) {
      this.franchiseeID = this.franchisee.id
    }
    this.getDestinations()
  },
  mounted: async function () {
    document.addEventListener('click', this.handleOutsideClick)
    await this.onFranchiseeChange()
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  watch: {
    franchisee: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.onFranchiseeChange()
      }
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    }),
    checkAllAssigned () {
      if (this.searching && !this.vendorsFiltered.length) return false

      let routeData = this.vendorsDestinationFormData.filter(item => {
        return this.selected.find(selectedItem => selectedItem.busID === item.busID && item.destinationID !== null)
      })
      let selectedData = this.selected
      return ((routeData.length === selectedData.length) && routeData.length !== 0 && selectedData !== 0)
    },
    itemsPerPage () {
      return this.isAssignRouteToAll ? -1 : 10
    },
    filteredOptions () {
      if (!this.newOptionName.trim()) {
        return this.destinations
      }
      const search = this.newOptionName.toLowerCase()
      return this.destinations.filter(item =>
        item.destination.toLowerCase().includes(search)
      )
    }
  },
  methods: {
    toggleDropdown (index) {
      if (this.openIndex === index) {
        this.isOpen = false
        this.openIndex = null
      } else {
        this.isOpen = true
        this.openIndex = index
      }
    },
    closeDropdown (index) {
      console.log('close', index, this.openIndex)
      if (index === undefined || index === this.openIndex) {
        this.isOpen = false
        this.openIndex = null
      }
      this.resetDropdown()
    },
    handleOutsideClick (event) {
      const selectWrappers = this.dropdownRefs[this.openIndex]
      if (!selectWrappers) return

      const wrapperArray = Array.isArray(selectWrappers) ? selectWrappers : [selectWrappers]
      const isClickInside = wrapperArray.some(wrapper => wrapper.contains(event.target))

      if (!isClickInside) {
        this.closeDropdown()
      }
    },
    resetDropdown () {
      this.isAdding = false
      this.newOptionName = ''
      this.editingOption = null
      this.editingOptionName = ''
    },
    selectOption (option, data) {
      this.vendorsDestinationFormData[data.srNo - 1].destinationID = option.id
      this.closeDropdown(data.busID)
    },
    showAddOption (index) {
      this.isAdding = true
      this.editingOption = null
      this.editingOptionName = ''
      this.$nextTick(() => {
        this.$refs.newOptionInput.focus()
      })
    },
    async addOption () {
      let isDestinationExists = false
      if (this.newOptionName.trim()) {
        this.destinations.forEach((item) => {
          if (item.destination.replace(/\s+/g, '').trim().toLowerCase() === this.newDestination.replace(/\s+/g, '').trim().toLowerCase()) {
            isDestinationExists = true
            return this.$buefy.toast.open({
              message: `Destination: ${item.destination} already exists!`,
              type: 'is-danger',
              duration: 3000
            })
          }
        })

        if (!isDestinationExists) {
          const payload = {
            destination: this.newOptionName
          }
          await http.post(`${constants.API_URL}/api/transport/destinations/create`, payload)
          this.getDestinations()
        }

        this.newOptionName = ''
        this.isAdding = false
      }
    },
    disableOptionSave (action) {
      if (action === 'edit' && this.editingOptionName) {
        if (this.editingOptionName.trim() === '') {
          return false
        }
        return this.destinations.some(data =>
          data.destination.replace(/\s+/g, '').trim().toLowerCase() ===
          this.editingOptionName.replace(/\s+/g, '').trim().toLowerCase()
        )
      } else if (this.newOptionName) {
        if (this.newOptionName.trim() === '') {
          return false
        }
        return this.destinations.some(item =>
          item.destination.replace(/\s+/g, '').trim().toLowerCase() ===
        this.newOptionName.replace(/\s+/g, '').trim().toLowerCase()
        )
      }
      return true
    },
    cancelAdd () {
      this.newOptionName = ''
      this.isAdding = false
      this.editingOption = null
    },
    editOption (option) {
      this.editingOption = option
      this.editingOptionName = option.destination
    },
    async saveOption () {
      try {
        if (this.editingOptionName.trim() && this.editingOption) {
          const payload = {
            destination: this.editingOptionName.trim()
          }

          const index = this.destinations.findIndex(
            (o) => o.id === this.editingOption.id
          )
          if (index !== -1) {
            await http.put(`${constants.API_URL}/api/transport/destinations/${this.destinations[index].id}/edit`, payload)
            this.getDestinations()
          } else {
            this.$buefy.toast.open({
              message: `Failed to update destination, Please refresh and retry!`,
              type: 'is-danger',
              duration: 3000
            })
          }
        }

        this.editingOption = null
        this.editingOptionName = ''
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 3000
        })
      }
    },
    cancelEdit () {
      this.editingOption = null
      this.editingOptionName = ''
    },
    getDestinationLabel (id) {
      let item = this.destinations.find(d => d.id === id)
      return item ? item.destination : 'Select Option'
    },
    handleInactiveDialog () {
      this.dialogInActive = false
      this.inactiveDialogVerified = true
      const inactiveSet = {
        inactiveDialogVerified: this.inactiveDialogVerified,
        inActiveVehicleDetails: this.inActiveVehicleDetails
      }
      localStorage.setItem('inactiveDataset', JSON.stringify(inactiveSet))
    },
    isInactiveDifferent (data1, data2) {
      const sortByBusID = (array) => array.slice().sort((a, b) => a.busID.localeCompare(b.busID))
      const stringifyObject = (obj) => JSON.stringify(obj)
      const sortedData1 = sortByBusID(data1)
      const sortedData2 = sortByBusID(data2)

      if (sortedData1.length !== sortedData2.length) {
        this.inactiveDialogVerified = false
        return true
      }
      for (let i = 0; i < sortedData1.length; i++) {
        if (stringifyObject(sortedData1[i]) !== stringifyObject(sortedData2[i])) {
          this.inactiveDialogVerified = false
          return true
        }
      }
      this.inactiveDialogVerified = true
      return false
    },
    renderingDestination (item) {
      if (item === 'edit' && this.editingDestination) {
        if (this.editingDestination.trim() === '') {
          return false
        }
        return this.destinations.some(data =>
          data.destination.replace(/\s+/g, '').trim().toLowerCase() ===
          this.editingDestination.replace(/\s+/g, '').trim().toLowerCase()
        )
      } else if (this.newDestination) {
        if (this.newDestination.trim() === '') {
          return false
        }
        return this.destinations.some(item =>
          item.destination.replace(/\s+/g, '').trim().toLowerCase() ===
        this.newDestination.replace(/\s+/g, '').trim().toLowerCase()
        )
      }
    },

    handleRenameRemove () {
      return new Promise((resolve) => {
        const showDialog = () => {
          this.$buefy.dialog.confirm({
            message: `
              <div style='text-align:center; font-weight:bold; margin-bottom: 15px;'>
                Before renaming the vehicle, it is mandatory to select one of the below options:
              </div>
              <div>
                <label style='display: block; margin-bottom: 15px;'>
                  <div style='display:flex;'>
                    <div>
                      <input type='radio' name='operationR' value='update' style='margin-right: 10px;'>
                    </div>
                    <div>
                      Only Rename & Maintain Student Allocation with Same Vehicle
                    </div>
                  </div>
                </label>
                <label style='display: block;'>
                  <div style='display: flex;'>
                    <div>
                      <input type='radio' name='operationR' value='nullify' style='margin-right: 10px;'>
                    </div>
                    <div>
                      Reallocate New Student to this Vehicle.
                      <p style='font-size: 12px; color: #666; margin-top: 5px;'>
                        (This will remove the existing allocated students)
                      </p>
                    </div>
                  </div>
                </label>
              </div>
            `,
            confirmText: 'SAVE',
            cancelText: 'CANCEL',
            onConfirm: () => {
              const selectedOption = document.querySelector('input[name="operationR"]:checked')
              if (selectedOption) {
                resolve(selectedOption.value)
              } else {
                this.$buefy.toast.open({
                  message: 'At least one option should be selected',
                  type: 'is-warning',
                  duration: 3000
                })
                showDialog()
              }
            }
          })
        }

        showDialog()
      })
    },
    makeSelection (data, index) {
      this.vendorsDestinationFormData[index].destinationID = data.item.id
      if (this.$refs.destinationSelect) {
        this.$refs.destinationSelect.blur()
      }
    },
    emptySelection () {
      let selectedRows = this.selected.map(i => i.busID)
      let selected = this.vendorsDestinationFormData.filter(item => selectedRows.includes(item.busID))
      if (selected.some(item => item.destinationID)) {
        this.$dialog.warning({
          title: 'All the entered data will be lost.',
          text: 'Are you sure you want to cancel the process?',
          actions: {
            false: {
              text: 'Not Now'
            },
            true: {
              color: 'success',
              text: 'Proceed Cancellation',
              handle: () => {
                this.selected = []
                this.isAssignRouteToAll = false
                this.clearAllFormData()
              }
            }
          }
        })
      } else {
        this.selected = []
        this.isAssignRouteToAll = false
      }
    },
    clearAllFormData () {
      this.vendorsDestinationFormData = this.vendorsDestinationFormData.map(vendor => ({ ...vendor, destinationID: null }))
    },
    editDestination (data) {
      this.isInputVisible = false
      this.isDestinationEditing = data.item.id
      this.editingDestination = data.item.destination
    },
    async saveEditDestination (data) {
      if (this.editingDestination) {
        const payload = {
          destination: this.editingDestination
        }
        if (data && data.item && data.item.id && payload && payload.destination) {
          await http.put(`${constants.API_URL}/api/transport/destinations/${data.item.id}/edit`, payload)
          this.getDestinations()
          this.getVehicleData()
          this.editingDestination = ''
          this.isDestinationEditing = null
        }
      }
    },
    showInput () {
      this.isInputVisible = true
      this.isDestinationEditing = null
    },
    hideInput (field) {
      this.isInputVisible = false
      this.newDestination = ''
      this.editingDestination = ''
      if (field === 'edit') {
        this.isDestinationEditing = null
      }
    },
    async addDestination () {
      let isDestinationExists = false
      if (this.newDestination.trim() !== '') {
        if (this.destinations) {
          this.destinations.forEach((item) => {
            if (item.destination.replace(/\s+/g, '').trim().toLowerCase() === this.newDestination.replace(/\s+/g, '').trim().toLowerCase()) {
              isDestinationExists = true
              return this.$buefy.toast.open({
                message: `Destination: ${item.destination} already exists!`,
                type: 'is-danger',
                duration: 3000
              })
            }
          })
        }
        if (!isDestinationExists) {
          const payload = {
            'destination': this.newDestination
          }
          await http.post(`${constants.API_URL}/api/transport/destinations/create`, payload)
          this.getDestinations()
          this.hideInput()
        }
      } else {
        this.hideInput()
      }
    },
    editRoute (select) {
      select(true)
    },
    async getDestinations () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/transport/destinations`)
        this.destinations = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: 'mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    filterVendors () {
      if (this.searchKey) {
        this.searching = true
        this.vendorsFiltered = this.vehicleList.filter(item =>
          item.transportVendor.ownerName.toLowerCase().includes(this.searchKey.toLowerCase())
        )
      } else {
        this.searching = false
        this.vendorsFiltered = []
      }
    },
    saveAssignRouteToAll () {
      let routeData = this.vendorsDestinationFormData.filter(item => { return this.selected.find(selectedItem => selectedItem.busID === item.busID && item.destinationID !== null) })
      routeData.map(async (item) => {
        let payload = {
          'busID': item.busID,
          'destinationID': item.destinationID
        }
        if (payload && payload.busID && payload.destinationID) {
          await http.put(`${constants.API_URL}/api/transport/destinations/vehicle-map`, payload)
          this.getVehicleData()
        }
      })
      this.isAssignRouteToAll = false
      this.removeSelected()
    },
    async assignRoute (busObj, index) {
      if (busObj.destinationID && this.vendorsDestinationFormData[index].destinationID) {
        const { data } = await http.get(`${constants.API_URL}/api/transport/students/mapped-vehicle?busId=${busObj.busID}`)
        if (data?.mappedStudents?.length > 0) {
          const val = await this.handleRenameRemove()
          let destinationId = this.vendorsDestinationFormData[index].destinationID
          if (val === 'update') {
            const payload = {
              destinationId
            }
            await http.put(`${constants.API_URL}/api/transport/students/mapped-vehicle?busId=${busObj.busID}`, payload)
          } else if (val === 'nullify') {
            const payload = {
              destinationId,
              moveToNull: true,
              previousDestination: busObj.destinationID
            }
            await http.put(`${constants.API_URL}/api/transport/students/mapped-vehicle?busId=${busObj.busID}`, payload)
          }
        }
        this.selected = []
        this.isAssignRouteToAll = false
        this.getVehicleData()
      }

      if (busObj && busObj.destinationID && busObj.transportDestination) {
        this.vendorsDestinationFormData[index].transportDestination = {
          destination: (this.destinations.find(item => item.id === this.vendorsDestinationFormData[index].destinationID)).destination
        }
      }
      const payload = {
        'busID': busObj.busID,
        'destinationID': parseInt(this.vendorsDestinationFormData[index].destinationID)
      }
      if (payload && payload.busID && payload.destinationID) {
        await http.put(`${constants.API_URL}/api/transport/destinations/vehicle-map`, payload)
        this.getVehicleData()
      }
      this.removeSelected()
    },
    assignRouteToAll (source) {
      if (source === 'headerCheckbox') {
        if (this.isAssignRouteToAll) {
          this.isAssignRouteToAll = false
          this.selected = []
          return
        }
      }
      if (this.searching) {
        this.selected = this.vendorsFiltered.filter(item => !item.destinationID)
      } else {
        this.selected = this.vehicleList.filter(item => !item.destinationID)
      }
      this.isAssignRouteToAll = true
    },
    removeSelected (select, index, item) {
      this.isDestinationEditing = null
      if (select) {
        select(false)
      } else {
        this.selected = []
      }
      this.newDestination = ''
      if (index !== undefined) {
        let previousDestination = item && item.destinationID ? item.destinationID : null
        this.vendorsDestinationFormData[index].destinationID = previousDestination
      }

      this.hideInput()
    },
    focusOut () {
      this.isDestinationEditing = null
      this.newDestination = ''
      // this.hideInput()
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee && this.franchisee.id) {
          this.franchiseeID = this.franchisee.id
        } else {
          let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
          this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
        }
        this.inProgress = false
        this.getVehicleData()
      }
    },
    getFranchiseeDataFromIndexDB: function () {
      let obj = stores.user.franchisee
      return obj
    },
    clearFilters () {
      this.searching = false
      this.searchKey = ''
    },
    async getVehicleData () {
      if (this.franchiseeID) {
        this.tableData = []
        const { data } = await http.get(`${constants.API_URL}/api/transport/destinations/vehicle-map?franchiseeID=${this.franchiseeID}`)
        if (data && data.rows.length !== 0) {
          let activeData = []
          this.vehicleDetails = data
          if (data.rows[0]?.transportVendor.isActive !== null) {
            activeData = data.rows.filter(row => row.transportVendor.isActive)
            this.inActiveVehicleDetails = data.rows.filter(row => !row.transportVendor.isActive)
            this.inActiveVehicleDetails.forEach((item, index) => {
              let inactive = {
                srNo: index + 1,
                vehicleNumber: item.vehicleRegistrationNumber + ' - ' + item.transportVendor.ownerName,
                destination: item.transportDestination ? item.transportDestination.destination ? item.transportDestination.destination : '-' : '-',
                deactivationReason: item.deactivateReason ? item.deactivateReason : '-'
              }
              this.tableData.push(inactive)
            })
            this.vehicleList = activeData.map((d, index) => ({ ...d, srNo: index + 1 })) || []
            this.vehicleDetails.totalVehicleCount = this.vehicleList.length
            this.vehicleDetails.routeAssignedVehicleCount = this.vehicleList.filter(item => item.transportDestination && item.transportDestination.destination !== null).length
          }

          this.vendorsDestinationFormData = this.vehicleList.map((item, index) => ({
            srNo: index,
            busID: item.busID,
            transportDestination: item.transportDestination ? item.transportDestination : null,
            destinationID: item.destinationID ? item.destinationID : null
          }))
          let inactiveSet = JSON.parse(localStorage.getItem('inactiveDataset'))
          if (inactiveSet) {
            this.isInactiveDifferent(this.inActiveVehicleDetails, inactiveSet.inActiveVehicleDetails)
          }
          if (this.tableData.length > 0 && this.showAtStart && !this.inactiveDialogVerified) {
            this.showAtStart = false
            this.dialogInActive = true
          }

          if (this.searching || this.searchKey) {
            this.filterVendors()
          }
        } else {
          this.vehicleList = []
          this.vehicleDetails.totalVehicleCount = 0
          this.vehicleDetails.routeAssignedVehicleCount = 0
          this.vendorsDestinationFormData = []
        }
      } else {
        this.$buefy.toast.open({
          message: 'Please select franchisee',
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    toggle (isSelected, select, index) {
      select(!isSelected)
    }
  }
}
</script>

<style scoped>
.table-cell-select {
  position: relative;
}

.select-field {
  background-color: #f0f0f0;
  padding: 8px;
  border: 1px solid #ddd;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dropdown-arrow {
  font-size: 12px;
}
.select-dropdown {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  z-index: 9;
}
.select-option,
.add-option {
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.addOptionsticky{
  position: sticky;
  top: 0px;
  z-index: 99;
}
.select-option:hover {
  background-color: #f0f0f0;
}
.add-option-input-container{
  padding: 0px 5px;
}
.add-option-input{
  border-radius: 5px;
}
.add-option-input:focus-visible{
 outline: none;
}

.add-option:hover {
  background-color: green
}
.select-option.selected {
  background-color: #e0e0e0;
}
.option-name {
  flex-grow: 1;
  cursor: pointer;
}
.edit-icon {
  cursor: pointer;
  padding: 4px;
}
.add-option {
  background-color: #4caf50;
  color: white;
  text-align: center;
  cursor: pointer;
}
.add-option-input,
.edit-input {
  width: calc(100% - 60px);
  padding: 6px;
  margin: 2px;
  border: 1px solid #ddd;
}

.add-option-input-container {
  display: flex
}
.save-button,
.cancel-button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 6px;
  margin: 2px;
  cursor: pointer;
  width: 24px;
}
.cancel-button {
  background-color: #f44336;
}

.tableData {
  padding: 20px;
  width: 100%;
}

.title-container {
  display: flex;
  align-items: center;
}

.cursor-pointer {
  cursor: pointer
}

.right-icon {
  margin-left: auto;
}
.hover-dark {
  background-color: #ebebeb;
}

.hover-dark:hover {
  background-color: #f0f0f0;
  transition: background-color 0.3s ease;
}
.hoverable-list-item {
  cursor: pointer;
}

.hoverable-list-item:hover {
  background-color: #f0f0f0;
}

</style>
